import axiosHttpClient from "../axiosHttpClient";

export function getResourceRevisions(revisionIds: string[]) {
	let ids=revisionIds.join();
	return axiosHttpClient.get('/recipe-resource-revisions/'+ids);
}
